export default __webpack_public_path__ + "static/event-dream-2611acf8ab1ac40cfdfb3baede429f04.jpg";